/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/addBlankChecklist.ts
 * FILE_ID: JOBHUB-QA-ADD-BLANK-CHECKLIST-001
 * PURPOSE: Add one blank checklist and its first step inside an existing area.
 */
// Reused from: qa/services/blank_checklist.py (_ensure_blank_checklist)
import type { QaApi } from '../../qa/qaApi'

export async function addBlankChecklist(
  api: Pick<QaApi, 'addChecklist' | 'addItem'>,
  areaId: string,
): Promise<string> {
  const created = await api.addChecklist(areaId, 'checklist', false)
  await api.addItem(areaId, { title: 'Checklist Step' }, null, null, created.id)
  return created.id
}
